<template>
	<div v-if="hasClasses" class="wrapper d-flex flex-column h-100">
		<v-form class="form">

			<v-row v-show="page===1"><v-col>
				<v-autocomplete outlined dense
					hide-details="auto"
					:label="$t('text.classes')"
					:multiple="true"
					return-object
					:items="classDef.items"
					v-model="classDef.selected"
					@change="classSelectionChanged">
					<template v-slot:selection="{ item }">
						<v-chip
							class="ma-1"
							close
							color="grey"
							text-color="black"
							dark
							label
							outlined>
							{{ item.text }}
						</v-chip>
					</template>
				</v-autocomplete>
			</v-col></v-row>
			<v-row v-show="page===1"><v-col>
				<v-autocomplete outlined dense
					hide-details="auto"
					:disabled="!hasSelectedClasses"
					:label="$t('text.events')"
					:multiple="true"
					return-object
					:items="event.items"
					v-model="event.selected"
					@change="eventSelectionChanged">
					<template v-slot:selection="{ item }">
						<v-chip
							class="ma-1"
							close
							color="grey"
							text-color="black"
							dark
							label
							outlined>
							{{ item.text }}
						</v-chip>
					</template>
				</v-autocomplete>
			</v-col></v-row>

			<div v-if="page===2" class="d-flex table-wrapper">
				<div class="blanker" ref="blanker"></div>
				<table :class="{ 'grid-error': hasError }" class="pr-3">
					<thead>
						<tr>
							<td rowspan="2"></td>
							<td class="header-td header-all">
								<div class="header-outer"><div class="header-inner">
									<div class="header-element">{{$t('text.all')}}</div>
								</div></div>
							</td>
							<td class="header-td" ref="header"
								v-for="(cl, i) in classDef.selected" :key="i">
								<div class="header-outer">
								<div class="header-inner">
								<div class="header-element">{{cl.text}}</div></div></div>
							</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="side-header-td header-all">
								{{$t('text.all')}}
							</td>
							<td></td>
							<td v-for="(cl, i) in classDef.selected" :key="i" class="checkbox unselectable all-classes">
									<div>
										<c-checkbox type="checkbox"
											:checkOnClickedMousover="true"
											@change="onBoxAllClassesChecked(cl.id)"
											:value="isAnyClassCheked(cl.id)"
											:indeterminate="isClassPartiallyChecked(cl.id)"
											:key="'all-' + cl.id">
										</c-checkbox>
									</div>
							</td>
						</tr>
						<tr v-for="(ev, i) in event.selected" :key="i">
							<td class="side-header-td" ref="sideHeader">
								{{ev.text}}
							</td>
							<td class="checkbox unselectable all-events">
								<div>
									<c-checkbox type="checkbox"
										:checkOnClickedMousover="true"
										@change="onBoxAllEventsChecked(ev.id)"
										:value="isAnyEventCheked(ev.id)"
										:indeterminate="isEventPartiallyChecked(ev.id)"
										:key="'all-' + ev.id">
									</c-checkbox>
								</div>
							</td>
							<td v-for="(cl, i) in classDef.selected" :key="i" class="checkbox">
								<div>
									<c-checkbox type="checkbox"
										:checkOnClickedMousover="true"
										@change="onBoxChecked(ev.id, cl.id)"
										:value="isChkBoxCheked(ev.id, cl.id)"
										:key="ev.id + '-' + cl.id">
									</c-checkbox>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</v-form>
		<v-spacer></v-spacer>
		<div class="f-row pb-1 buttons">
			<v-btn
				class="mr-4"
				:disabled="!hasSelectedClasses || !hasSelectedEvents || hasError"
				@click="saveEventClassDef">
				{{ $t(`text.createAndNext`) }}
			</v-btn>
			<v-btn
				class="mr-4"
				@click="backToUpdate">
				{{ $t(`text.abortNoSave`) }}
			</v-btn>
			<v-btn
				class="mr-4"
				@click="back">
				{{ $t(`text.backButton`) }}
			</v-btn>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import namespace from '../store/namespace';
import performanceActions from '../store/actions/performance';
import bestListActions from '../store/actions/bestList';

import CCheckbox from '../general/CCheckbox.vue';


export default {
	name: 'CustomDefCombinations',
	components: {
		CCheckbox,
	},
	data() {
		return {
			event: {
				items: [],
				selected: [],
			},
			classDef: {
				items: [],
				selected: [],
			},
			eventClasses: [],
			hasError: false,
			customEventClasses: null,
			id: this.$route.params.id || null,
		};
	},
	async mounted() {
		await this.getEvents();
		await this.getClassDefs();
		await this.getCustomDefs();
		this.setEventsAndClasses();

		this.$nextTick(() => {
			this.$emit('onlaodingfinished');
		});
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.BESTLIST, ['Links']),
		hasClasses() {
			return this.classDef.items.length > 0;
		},
		hasEvents() {
			return this.event.items.length > 0;
		},
		hasSelectedClasses() {
			return this.classDef.selected.length != 0;
		},
		hasSelectedEvents() {
			return this.event.selected.length != 0;
		},
		page() {
			return this.$route.name == 'customDefinitionsMatrix' ? 2 : 1;
		},
		isChkBoxCheked: state => (eId, cId) => !!state.eventClasses.find(x => x.classId === cId && x.eventId === eId),
		isAnyClassCheked: state => cId => !!state.eventClasses.find(x => x.classId === cId),
		isAnyEventCheked: state => eId => !!state.eventClasses.find(x => x.eventId === eId),
		isClassPartiallyChecked: state => (cId) => {
			if (!state.eventClasses.length) return false;
			const count = state.eventClasses.reduce((a, x) => (x.classId === cId ? a + 1 : a), 0);
			return ![0, state.event.selected.length].includes(count);
		},
		isEventPartiallyChecked: state => (eId) => {
			if (!state.eventClasses.length) return false;
			const count = state.eventClasses.reduce((a, x) => (x.eventId === eId ? a + 1 : a), 0);
			return ![0, state.classDef.selected.length].includes(count);
		},
	},
	methods: {
		...mapActions(namespace.PERFORMANCE, [
			performanceActions.FETCH_EVENTS,
			performanceActions.FETCH_CLASSES,
		]),
		...mapActions(namespace.BESTLIST, [
			bestListActions.GET_CUSTOM_DEFS,
		]),
		setGridHeight() {
			if (this.$refs.blanker) {
				this.$refs.blanker.style.width = this.$refs.sideHeader !== undefined ? `${this.$refs.sideHeader[0].clientWidth}px` : 0;
				this.$refs.blanker.style.height = this.$refs.header !== undefined ? `${this.$refs.header[0].clientHeight}px` : 0;
			}
		},
		async getEvents() {
			try {
				this.event.items = await this.FETCH_EVENTS(this.id);
			} catch (e) {
				console.log(e);
			}
		},
		async getClassDefs() {
			try {
				this.classDef.items = await this.FETCH_CLASSES(this.id);
			} catch (e) {
				console.log(e);
			}
		},
		async getCustomDefs() {
			if (this.id != null) {
				const link = this.Links.find(x => x.rel === 'get_custom_defs');
				const href = link.href.replace('{performanceListId}', this.id);
				this.customEventClasses = await this.GET_CUSTOM_DEFS({ href });
			}
		},
		setEventsAndClasses() {
			if (this.customEventClasses && this.customEventClasses.length != 0) {
				this.eventClasses = this.customEventClasses.map(x => ({ classId: x.classId, eventId: x.eventId }));

				this.classDef.selected = this.classDef.items.filter(x => this.eventClasses.find(y => y.classId == x.id));
				this.event.selected = this.event.items.filter(x => this.eventClasses.find(y => y.eventId == x.id));
			}
		},
		classSelectionChanged() {
			if (this.classDef.selected.length != 0) {
				this.classDef.selected.sort((a, b) => (a.order > b.order ? 1 : -1));
			}
			this.eventClasses = this.eventClasses.filter(y => this.classDef.selected.map(x => x.id).includes(y.classId));
		},
		eventSelectionChanged() {
			if (this.event.selected.length != 0) {
				this.event.selected.sort((a, b) => (a.order > b.order ? 1 : -1));
			}
			this.eventClasses = this.eventClasses.filter(y => this.event.selected.map(x => x.id).includes(y.eventId));
		},
		onBoxAllClassesChecked(cId) {
			const i = this.eventClasses.findIndex(x => x.classId === cId);
			if (i !== -1) {
				this.eventClasses = this.eventClasses.filter(x => x.classId !== cId);
			} else {
				this.event.selected.forEach(e => this.eventClasses.push({ eventId: e.id, classId: cId }));
			}
		},
		onBoxAllEventsChecked(eId) {
			const i = this.eventClasses.findIndex(x => x.eventId === eId);
			if (i !== -1) {
				this.eventClasses = this.eventClasses.filter(x => x.eventId !== eId);
			} else {
				this.classDef.selected.forEach(c => this.eventClasses.push({ eventId: eId, classId: c.id }));
			}
		},
		onBoxChecked(eId, cId) {
			const i = this.eventClasses.findIndex(x => x.classId === cId && x.eventId === eId);
			if (i !== -1) {
				this.eventClasses.splice(i, 1);
			} else {
				this.eventClasses.push({ eventId: eId, classId: cId });
			}
			this.hasError = false;
		},
		async saveEventClassDef() {
			this.$emit('onlaodingstarted');
			if (this.page === 1) {
				this.$router.push({
					name: 'customDefinitionsMatrix',
					params: {
						id: this.id,
					},
				});
				this.$nextTick(() => {
					this.$emit('onlaodingfinished');
					this.$nextTick(this.setGridHeight());
				});
				return;
			}

			const finalCustomDefs = this.eventClasses.map(x => ({ eventId: x.eventId, classId: x.classId, performanceListId: this.id }));
			if (finalCustomDefs.length != 0) {
				this.$emit('oncreateeventclassdef', finalCustomDefs);
			} else {
				this.hasError = true;
				this.$emit('onlaodingfinished');
			}
		},
		backToUpdate() {
			this.$router.push({
				name: 'updatebestlist',
				params: {
					id: this.id,
				},
			});
		},
		back() {
			if (this.$route.name === 'customDefinitionsMatrix') {
				this.$router.push({
					name: 'customDefinitions',
					params: {
						id: this.id,
					},
				});
			} else {
				this.$router.push({
					name: 'updatebestlist',
					params: {
						id: this.id,
					},
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>

.wrapper {
	height: 100%;
}

.table-wrapper {
    flex: 1 1 auto;
    min-width: 0px;
    min-height: 200px;
	position: relative;
}

.form{
    overflow: hidden;
	overflow-y: auto;
	max-height: 100%;
    display: flex;
    flex-direction: column;
}

.buttons {
	overflow: none;
}

table {
	display: block;
	overflow: auto;
    max-width: fit-content;
	border: solid 1px transparent;
	border-spacing:0;
}

.blanker {
	background-color:#fff;
	position: absolute;
	z-index: 1;
	top:1px;
	left:1px;
}

thead td {
	position: sticky;
	top: 0;
}

.header-td {
	background-color: #fff;
}

.header-outer {
	display: grid;
	width: 25px;
	overflow: hidden;
}
.header-inner {
	padding: 50% 0;
	height: 0;
}

.header-element {
	display: block;
  transform-origin: top left;
  transform: rotate(-90deg) translate(-100%);
  margin-top: -50%;
  white-space: nowrap;
}

.side-header-td {
	width: 1%;
    white-space: nowrap;
    padding-right: 15px;
	position: sticky;
	left: 0;
	background-color: #fff;
	border-color: #fff;
}

.header-all {
	font-weight: bolder;
}

.all-events {
	border-right:1px solid black;
}

.all-classes {
	border-bottom:1px solid black;
}

.grid-error {
	border: solid 1px red;
}

.checkbox {
	text-align: center;
	padding-left:5px;
}

.unselectable {
   -moz-user-select: -moz-none;
   -khtml-user-select: none;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
}
</style>
